// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1533":"75d99076","3669":"f8a3e400","6951":"b8d7202e","8845":"bc781a7f"}[chunkId] + ".chunk.css";
};